import { FunctionComponent, ReactNode } from "react";

interface FeedEmptyStateProps {
	title: string;
	description?: string;
	action?: ReactNode;
}

/** Centered empty-state box shared by the Feed page's zero-data situations. */
export const FeedEmptyState: FunctionComponent<FeedEmptyStateProps> = ({
	title,
	description,
	action,
}) => (
	<div
		className="flex flex-col items-center justify-center gap-2 py-16 px-4 text-center"
		data-testid="feed-empty-state"
	>
		<p className="text-sm font-semibold text-text">{title}</p>
		{description && <p className="text-xs text-text-meta max-w-[360px]">{description}</p>}
		{action && <div className="mt-2">{action}</div>}
	</div>
);
